const getDefaultState = () => {
    return {  
      partnerSessionCount: 0,
    };
  };
  
  const state = getDefaultState();
  
  // Synchronous
  const mutations = {
    /* CORE ROOM STATE */
    RESET(state) {
      Object.assign(state, getDefaultState());
    },

    SET_PARTNER_SESSION_COUNT(state, sessionCount) {
      state.partnerSessionCount = sessionCount;
    },
  };
  
  // Asynchronous
  const actions = {
    /* CORE STATE */
    reset({ commit }) {
      commit("RESET");
    },
  
    setPartnerSessionCount({ commit }, sessionCount) {
      commit("SET_PARTNER_SESSION_COUNT", sessionCount);
    },
  };
  
  const remoteProfileData = {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  
  export default remoteProfileData;
  